export default {
      header: {
        welcome: "Welcome",
        search_placeholder: "Search products, orders...",
        my_products: "My Products",
        add_product: "Add New Product",
        orders: "Orders",
        offers: "Offers",
        reports: "Reports",
        support: "Support",
        help: "Help",
        control_tower: "Control Tower",
        supplier_approval: "Supplier Approval",
        restaurant_approval: "Restaurant Approval",
        credit_management: "Credit Management",
        monitoring: "Monitoring",
        promotions: "Promotions",
        promotion_request: "Promotion Requests",
        paid_promotions: "Paid Promotions",
        coupon_management: "Coupon Management",
        support_tickets: "Support Tickets",
        credit_settlement: "Credit Settlement",
        supplier_payments: "Supplier Payments",
        profile_changes: "Profile Changes",
        user_management: "User Management",
        create_user: "Create User",
        logout: "Logout",
        overview: "Overview",
        today_orders: "Today Orders",
        active_suppliers: "Active Suppliers",
        admin: "Admin",
        orders_trend: "Orders Trend",
        revenue_trend: "Revenue Trend",
        top_suppliers: "Top Suppliers",
        recent_activity: "Recent Activity",
        system_insights: "System Insights",
        pending_orders: "Pending Orders",
        failed_orders: "Failed Orders",
        active_restaurants: "Active Restaurants",
        today_revenue: "Today Revenue",
        monthly_revenue: "Monthly Revenue",
        open_tickets: "Open Tickets",
        credit_given: "Credit Given",
        credit_collected: "Credit Collected",
        outstanding_credit: "Outstanding Credit",
        overdue_credit: "Overdue Credit",
        avg_order_value: "Avg Order Value",
        success_rate: "Success Rate",
        cancellation_rate: "Cancellation Rate",
        needs_attention: "Needs Attention",
        order_status: "Order Status",
        today: "Today",
        days: "Days",
        month: "Month",
        financial_health: "Financial & Health",
        credit_risk_restaurants: "Credit Risk Restaurants",
        inactive_suppliers: "Inactive Suppliers",
        order: "Order",
        status: "Status",
        date: "Date",
        stuck_orders: "Stuck Orders",
        failed_payments: "Failed Payments",
        pending_suppliers: "Pending Suppliers",
        high_priority_tickets: "High Priority Tickets",
        sla_breach: "SLA Breach", 
      },
      sidebar: {
        overview: "Overview",
        basic_info: "Basic Info",
        supplier_info: "Supplier Info",
        restaurant_info: "Restaurant Info",
        address: "Address",
        bank: "Bank Details",
        documents: "Documents",
        supplier_branch: "Supplier Branch",
        restaurant_branch: "Restaurant Branch",
        supplier_store: "Supplier Stores",
        restaurant_store: "Restaurant Stores",
        settings: "Settings",

        back_to_dashboard: "Back to Dashboard",
        supplier: "Supplier",
        restaurant: "Restaurant",
        complete: "Complete",
      },
      overview: {
        profile_completed: "Profile Completed",
        supplier_profile: "Supplier Profile",
        restaurant_profile: "Restaurant Profile",
        verified: "Verified",
        rejected: "Rejected",
        pending_verification: "Verification Pending",
        completed: "Completed",
        incomplete: "Incomplete",
        basic_info: "Basic Info",
        company: "Company",
        address: "Address",
        bank: "Bank",
        branches: "Branches",
        store: "Store",
        name: "Name",
        email: "Email",
        phone: "Phone",
        cr_number: "CR Number",
        vat_number: "VAT Number",
        city: "City",
        bank: "Bank",
        iban: "IBAN",
        total_branches: "Total Branches",
      },
      basicinfo: {
        title: "Basic Info",
        full_name: "Full Name",
        company_name: "Company Name",
        email: "Email",
        phone: "Phone",
        profile_type: "Profile Type",
      },
      companyinfo: {
        title_supplier: "Supplier Details",
        title_restaurant: "Restaurant Details",
        company_name_supplier: "Supplier Company Name",
        company_name_restaurant: "Restaurant Name",
        email: "Email",
        cr_number: "CR Number",
        cr_expiry: "CR Expiry",
        comp_card_number: "Computer Card Number",
        comp_card_expiry: "Computer Card Expiry",
        signing_authority: "Signing Authority",
        sponsor_name: "Sponsor Name",
        trade_license: "Trade License Name",
        vat_number: "VAT Number",
        category: "Category",
        brand_name: "Brand Name",
        digits_6_10: "Digits only (6–10 numbers)",
        digits_7_12: "Digits only (7–12 numbers)",
        vat_hint: "15-digit VAT number",
        trade_license_hint: "Must match trade license exactly",
        email_placeholder: "Company email",
      },
      address: {
        title: "Address Information",
        address: "Address",
        street: "Street",
        zone: "Zone",
        area: "Area",
        city: "City",
        country: "Country",
        select: "Select"
      },
      profilebank: {
        title: "Bank Details",
        bank_name: "Bank Name",
        account_holder: "Account Holder",
        branch: "Branch",
        iban: "IBAN",
        swift: "Swift Code",
        iban_hint: "Required for international payments",
        swift_hint: "Used for international transfers",
        bank_name_placeholder: "e.g. HDFC Bank",
        account_holder_placeholder: "Name as per bank records",
        branch_placeholder: "Branch name",
        iban_placeholder: "Country code + number",
        swift_placeholder: "8 or 11 characters"
      },
      documents: {
        title: "Attachments",
        cr_copy: "CR Copy",
        comp_card: "Computer Card Copy",
        trade_license: "Trade License Copy",
        vat_certificate: "VAT Certificate",
        company_logo: "Company Logo",
        bank_letter: "Bank Letter",
        certificates: "Certificates",
        food_safety: "Food Safety Certificate",
        upload_file: "Upload file",
        uploaded_file: "Uploaded file",
        no_file: "No file selected",
        choose_file: "Choose File",
      },
      branch: {
        title_supplier: "Supplier Branch Registration",
        title_restaurant: "Restaurant Branch Registration",
        multiple: "Multiple Branches?",
        total: "Total Branches",
        branch_progress: "Branch {{current}} of {{total}}",

        branch_name_en: "Branch Name (EN)",
        branch_name_ar: "Branch Name (AR)",
        manager: "Branch Manager",
        contact: "Contact",
        email: "Email",
        street: "Street",
        zone: "Zone",
        building: "Building",
        office: "Office No",
        city: "City",
        country: "Country",
        license: "Branch License",
      },
      store: {
        title_supplier: "Supplier Store Details",
        title_restaurant: "Restaurant Store Details",
        branch: "Branch",
        select_branch: "Select branch",
        name_en: "Store Name (English)",
        name_ar: "Store Name (Arabic)",
        contact_name: "Contact Person Name",
        contact_mobile: "Contact Person Mobile",
        email: "Email",
        street: "Street",
        zone: "Zone",
        city: "City",
        building: "Building",
        shop: "Shop No",
        hours: "Operating Hours",
        store_type: "Store Type",
        retail: "Retail",
        warehouse: "Warehouse",
        delivery_pickup: "Delivery / Pickup",
        delivery: "Delivery",
        pickup: "Pickup",
        both: "Both",
        hours_placeholder: "9:00 AM - 6:00 PM",
        store_placeholder: "Enter store name",
        mobile_digits: "Must be 10 digits",
      },
      settings: {
        title: "Account Settings",
        preferences: "Preferences",
        notifications: "Notifications",
        profile: "Profile Visibility",
        security: "Security",

        language: "Language",
        timezone: "Timezone",
        currency: "Currency",

        email_notify: "Email Notifications",
        sms_notify: "SMS Notifications",
        whatsapp_notify: "WhatsApp Notifications",
        order_updates: "Order Status Updates",
        promo_alerts: "Promotional Alerts",

        profile_visible: "Public Supplier Profile",
        show_contact: "Show Contact Details",

        two_factor: "Two-Factor Authentication (2FA)",
        login_alerts: "Login Alerts",
        device_verification: "New Device Verification",

        save: "Save Settings"
      },
      alerts: {
        no_edit: "Basic Info cannot be edited",
        invalid_email: "Invalid email ❌",
        invalid_phone: "Invalid phone ❌",
        no_data: "No data to save ❌",
        saved: "Saved ✅",
        sent_for_approval: "Sent for approval ✅",
        session_expired: "Session expired ❌",
        no_changes: "No changes detected",
        no_changes_address: "No changes detected in Address",
        update_failed: "Update failed ❌",
        no_changes_bank: "No changes detected in Bank Details",
        no_changes_documents: "No changes detected in Documents",
        no_files: "No files selected ❌",
        save_failed: "Save failed ❌",
        error_saving: "Error saving files ❌",
        no_changes_branch: "No changes detected in Branches",
        no_changes_store: "No changes detected in Store",
        error_saving_store: "Error saving store ❌"
      },
      buttons: {
        edit: "Edit",
        saving: "Saving...",
        next: "Next",
        save_next: "Save & Next",
        back: "Back",
        previous: "Previous Branch",
        next_branch: "Save & Next Branch",
        finish: "Finish"
      },
      validation: {
        cr_number: "CR must be 6–10 digits",
        vat_number: "VAT must be 15 digits",
        required: "Required",
        required_field: "{{field}} is required"
      },
      common: {
        select: "Select",
        yes: "Yes",
        no: "No"
      }
    }